import { all, call, fork, put, take} from "redux-saga/effects";

import {IClientBrowsingHistoryRepository} from "../../domain/repository/client_browsing_history_repository";

import {createClientBrowsingHistoryAPI} from "../../infra/api/service/client_browsing_history_api";
import {createApiClient, IApiClient} from "../../infra/api/client";

import {handleErrorForHandler} from "./handleErrorForHandler";
import {
    ClientClientBrowsingHistoriesActionType,
    createClientClientBrowsingHistoriesActionCreator,
    IClientClientBrowsingHistoriesActionCreator,
    IRequestGetAllClientBrowsingHistoriesAction,
} from "../action/client_client_browsing_histories_action";
import {ClientBrowsingHistory} from "../../domain/model/client_browsing_history";
import {GetAllClientBrowsingHistoryByClientResponse} from "../response/client_browsing_history_response";
import {Customer} from "../../domain/model/customer";
import {ICustomerRepository} from "../../domain/repository/customer_repository";
import {createCustomerAPI} from "../../infra/api/service/customer_api";
import {IJobCareerRepository, TJobCareerWithCustomerID} from "../../domain/repository/job_career_repository";
import {createJobCareerAPI} from "../../infra/api/service/job_career_api";
import {Pager} from "../../domain/model/common";
import {ClientBookmark} from "../../domain/model/client_bookmark";
import {createClientBookmarkAPI} from "../../infra/api/service/client_bookmark_api";
import {IClientBookmarkRepository} from "../../domain/repository/client_bookmark_repository";

const apiClient: IApiClient = createApiClient();
const clientBrowsingHistoryRepository: IClientBrowsingHistoryRepository = createClientBrowsingHistoryAPI(apiClient);
const customerRepository: ICustomerRepository = createCustomerAPI(apiClient);
const jobcareerRepository: IJobCareerRepository = createJobCareerAPI(apiClient);
const clientBookmarkRepository: IClientBookmarkRepository = createClientBookmarkAPI(apiClient);
const actionCreator: IClientClientBrowsingHistoriesActionCreator = createClientClientBrowsingHistoriesActionCreator();

function* handleGetAllClientBrowsingHistoriesInClientClientBrowsingHistories() {
    while (true) {
        try {
            const action: IRequestGetAllClientBrowsingHistoriesAction = yield take(ClientClientBrowsingHistoriesActionType.REQUEST_GET_ALL_CLIENT_BROWSINGHISTORIES);
            const clientBrowsingHistories: ClientBrowsingHistory[] = yield call(getAllClientBrowsingHistory, action.item.pager);
            const customerIds: string[] = yield call(createCustomerIds, clientBrowsingHistories);
            let customerCount: number;
            let customers: Customer[];
            let jobCareersWithCustomerId: TJobCareerWithCustomerID[];
            let clientBookmarks: ClientBookmark[];
            [customers, jobCareersWithCustomerId, customerCount, clientBookmarks] = yield all([
                call(getCustomerAllByIDs, customerIds),
                call(getJobcareerAllByCustomerIDs, customerIds),
                call(getCountByClient),
                call(getAllClientBookmark)
            ]);

            const res: GetAllClientBrowsingHistoryByClientResponse = new GetAllClientBrowsingHistoryByClientResponse();
            res.clientBrowsingHistories = clientBrowsingHistories;
            res.customerCount = customerCount;
            res.customers = customers;
            res.jobCareersWithCustomerID = jobCareersWithCustomerId;
            res.clientBookmarks = clientBookmarks;
            yield put(actionCreator.callbackGetAllClientBrowsingHistoriesAction(true,res));

        } catch (error) {
            yield fork(handleErrorForHandler, error);
            yield put(actionCreator.callbackGetAllClientBrowsingHistoriesAction(false));
        }
    }
}

const getAllClientBrowsingHistory = (pager: Pager): Promise<ClientBrowsingHistory[]> => {
    return clientBrowsingHistoryRepository.getAllByClient(pager.page, pager.offset);
};

const createCustomerIds = (clientBrowsingHistories: ClientBrowsingHistory[]): string[] => {
    return clientBrowsingHistories.map((clientBrowsingHistory: ClientBrowsingHistory) => {
        return clientBrowsingHistory.customerID
    })
};

const getCustomerAllByIDs = (customerIds: string[]): Promise<Customer[]> => {
    return customerRepository.getAllByIDs(customerIds);
};

const getJobcareerAllByCustomerIDs = (
    customerIds: string[],
): Promise<TJobCareerWithCustomerID[]> => {
    return jobcareerRepository.getAllByCustomerIDsForScout(
        customerIds,
    );
};

const getCountByClient = (): Promise<number | Long> => {
    return clientBrowsingHistoryRepository.getCountByClient();
};

const getAllClientBookmark = (): Promise<ClientBookmark[]> => {
    return clientBookmarkRepository.getAllByClient();
};

export {handleGetAllClientBrowsingHistoriesInClientClientBrowsingHistories}



// WEBPACK FOOTER //
// ./src/presentation/handler/client_client_browsing_histories_handler.ts